<template>
  <div id='container'>
    <div id='top'>
      <h1>总裁信箱</h1>
      <!-- 按钮组 -->
      <van-row style='text-align:center'>
        <van-col span="6"><base-button plain type='primary' class='btn-style' @click="onClickRefreshBtn">查询邮件</base-button></van-col>
        <van-col span="6" v-if='!isPresident'><base-button plain type='info' class='btn-style' @click="onClickAddBtn">写信</base-button></van-col>
        <!-- <van-col span="6"><base-button plain type='default' class='btn-style' @click="onClickParamsBtn">查询条件</base-button></van-col> -->
      </van-row>
    </div>
    
    <div id='center'>
      <!-- 邮件列表 -->
      <base-list ref='list' :list='mailList' @load='onLoadList' @clickItem='onClickItem'>
        <div slot='icon'>
          <van-icon name="chat-o" color="#11c677"  size="1.5rem" />
        </div>
      </base-list>
    </div>
    
    <div id='bottom'/>

    <!-- 编辑信息弹出框 -->
    <base-popup ref='popup' class='base-popup' :round='true'>
      <div slot='content'>
        <mail-editor :data='currentMail' :isAdd='isAdd' :isPresident='isPresident'
                     @closed='onPopupClosed'/>
      </div>
    </base-popup>

    <!-- 查询条件弹出框 -->
    <base-popup ref='popup_1' class='base-popup' :round='true' style='height: 50%'>
      <div slot='title'>查询条件</div>
      <div slot='content'>
        <base-radio-group :options='mailStatusList' title='邮件状态' :initVal='qc.status'
                          @change='onStatusChange'/>
        <br>
        <base-field title='邮件标题' :initVal='qc.title' @change='onTitleChange' placeholder='邮件标题关键词'/>
        <br><br>
        <van-button plain round block type='primary' @click='queryMailList'>
          查询邮件
        </van-button>
      </div>
      
    </base-popup>
  </div>
</template>

<script>
import BaseButton from '../base/BaseButton';
import BasePopup from '../base/BasePopup';
import BaseList from '../base/BaseList';
import BaseField from '../base/BaseField';
import BaseRadioGroup from '../base/BaseRadioGroup';
import MailEditor from './edit';
import { presidentMailList } from '@/api/presidentMailbox';

export default {
  components: { BaseButton, BasePopup, BaseList, BaseField, BaseRadioGroup, MailEditor },
  name: 'PresidentMailboxList',
  data() {
    return {
      data: null,
      mailList: null,
      isAdd: null,
      isPresident: null,
      currentMail: {},
      empId: this.$store.getters.userInfo.emp_id,
      mailStatusList: this.CONST.PRESIDENT_MAIL_STATUS,
      qc: {
        title: '',
        status: 3, // 查全部
        create_id: null,
        rows: 99999
      }
    }
  },
  methods: {
    onTitleChange(val) {
      this.qc.title = val;
    },
    onStatusChange(val) {
      this.qc.status = Number(val);
    },
    onLoadList() {
      let data = {};
      Object.assign(data, this.qc);
      
      if (data.status === 3) {
        delete data.status;
      }

      data.title = data.title.trim();

      // 不是总裁
      if (!this.isPresident) {
        data.create_id = this.empId;
      }

      presidentMailList(data).then(resp => {
        if (resp && resp.success) {
          this.mailList = resp.rows;

          this.$refs.list.finished = true;
          this.$refs.list.loading = false;
          this.$refs.list.refreshing = false;
        }
      });
    },
    onClickRefreshBtn() {
      this.$refs.popup_1.isShow = true;
      // this.$refs.list.onRefresh();
    },
    queryMailList() {
      this.$refs.popup_1.isShow = false;
      this.$refs.list.onRefresh(this.qc);
    },
    onClickAddBtn() {
      this.currentMail = {};
      this.isAdd = true;
      this.$refs.popup.isShow = true;
    },
    onClickItem(item) {
      this.currentMail = item;
      this.isAdd = false;
      this.$refs.popup.isShow = true;
    },
    onPopupClosed() {
      this.currentMail = {};
      // this.onClickRefreshBtn();
      this.queryMailList();
    },
    
  },
  created() {
    this.isPresident = this.$store.getters.userInfo.username === '春雪-苏宁';
  },
  mounted() {
    // this.onClickRefreshBtn();
    this.queryMailList();

    const ratio = 0.1;
    document.getElementById('container').style.paddingBottom = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) * ratio + 'px';
    document.getElementById('bottom').style.height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) * ratio + 'px';
  }
}
</script>

<style scoped>
h1 {
  font-size: 34px;
  color: #333;
}
.btn-style {
  width: 90%;
}
#top {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  padding-top: 5%;
  padding-left: 5%;
  width: 100%;
  height: 150px;
  background-color: #ecf0f0;
}
#center {
  margin-top: 190px;
  padding-left: 5%;
  padding-right: 5%;
}
#bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/president-mailbox/list.vue